import React from 'react';
import { Provider } from 'react-redux';
import ReactDOM from 'react-dom/client';
import { HashRouter } from 'react-router-dom';
import App from './App'

import './index.css';
import './mobile-enhancements.css';
import store from './Store/store'
import { installFetchLoadingInterceptor } from './Utility Components/loadingEvents';

const root = ReactDOM.createRoot(document.getElementById('root'));

installFetchLoadingInterceptor();

root.render(
  <HashRouter>
    <Provider store={store}>
      <App/>
    </Provider>
  </HashRouter>
);

